class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      }
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }
}
customElements.define("m-footer", MFooter);




(() => {
  // Any click on .tt-rating-text triggers 15% scroll (from TOP)
  const onClick = (e) => {
    const trigger = e.target.closest('.tt-rating-text');
    if (!trigger) return;

    e.preventDefault();

    const doc = document.documentElement;
    const scrollRange = doc.scrollHeight - doc.clientHeight; // वास्तविक scrollable range
    const targetY = Math.max(0, Math.round(scrollRange * 0.21));

    window.scrollTo({ top: targetY, behavior: 'smooth' });
  };

  // Make it look clickable
  const markClickable = () => {
    document.querySelectorAll('.tt-rating-text').forEach(el => {
      el.style.cursor = 'pointer';
    });
  };

  document.addEventListener('click', onClick);
  document.addEventListener('DOMContentLoaded', markClickable);
  document.addEventListener('shopify:section:load', markClickable);
})();




